import { EntityListCustomMessages, EntityListSkuQuantityInputData } from '../entityListTypes';
import { EntityListSpecification } from './EntityListSpecification';
import { ProjectAdministrationSubpage } from '../../../projectAdministrationLib';
import { SkuQuantityEntityListContentStructure } from '../content_structure/SkuQuantityEntityListContentStructure';
import { EntityListSkuQuantityItemConverter } from '../converters/EntityListSkuQuantityItemConverter';
import { EntityListSkuQuantityItemValidator } from '../validators/EntityListSkuQuantityItemValidator';
import { ImportFormatItem } from '../../../../../lib/imports/importTypes';
import { SkuQuantityInputFormatProvider } from '../input_formats/SkuQuantityInputFormatProvider';
import { EntityListItemType } from '@ydistri/api-sdk';

/**
 * Intermediary class for lists that contain SKUs and quantity.
 * This class sets proper content structure, converter, and validator.
 * Specific classes should inherit from this class and pass subpage, pageTitle, title, and url in the constructor.
 */
export class SkuQuantityEntityListSpecification extends EntityListSpecification<EntityListSkuQuantityInputData> {
  public readonly itemType = EntityListItemType.SkuQuantity;
  protected allowZeroQuantity: boolean;

  // eslint-disable-next-line max-params -- for another time
  constructor(
    subpage: ProjectAdministrationSubpage,
    pageTitle: string,
    title: string,
    menuOptionTitle: string,
    shortName: string,
    customMessages: EntityListCustomMessages | undefined,
    allowZeroQuantity = false,
  ) {
    super(
      {
        subpage,
        pageTitle,
        title,
        menuOptionTitle,
        shortName,
        customMessages,
      },
      new SkuQuantityEntityListContentStructure(),
      new EntityListSkuQuantityItemConverter(),
      new EntityListSkuQuantityItemValidator(allowZeroQuantity),
      new SkuQuantityInputFormatProvider(),
    );
    this.allowZeroQuantity = allowZeroQuantity;
  }

  getUniqueItemsForDuplicateCheck(): ImportFormatItem<EntityListSkuQuantityInputData>[] {
    return this.getInputFormat().filter(item => {
      return item.id === 'product' || item.id === 'store';
    });
  }
}
